import ModuleKaleidoscopeStore from '../Module/ModuleKaleidoscope/_stores/ModuleKaleidoscopeStore';
import ModuleWallpaperGroupsStore from '../Module/ModuleWallpaperGroups/_stores/ModuleWallpaperGroupsStore';
import { ModuleAction } from '../Module/_actions/ModuleActions';
import { ModuleTypes } from '../Module/_config/ModuleInfo';
import ModuleStore from "../Module/_stores/ModuleStore";
import KaleidoscopeShader from "../Webgl/Shader/KaleidoscopeShader";
import WallpaperGroupsShader from "../Webgl/Shader/WallpaperGroupsShader";
import * as Uniform from "../Webgl/Uniform";
import Webgl from "../Webgl/Webgl";
import { IHandler } from "./ModuleHandler";

export default class TransformHandler implements IHandler {
	public getOutput(module: ModuleStore, webgl: Webgl, documentWidth:number, documentHeight:number, quality:number, useChunks:boolean, updater: (key:string, value:any) => ModuleAction) {
		let store:any = undefined;

		let fbo = webgl.fbos[webgl.currentFramebuffer];
		let inputSizeWidth:number = fbo.width * (100 / quality);
		let inputSizeHeight:number = fbo.height * (100 / quality);

		switch(module.get('type')) {
			case ModuleTypes.WallpaperGroups:
				store = module as ModuleWallpaperGroupsStore;

				if(!webgl.programs["wallpaper_groups"]) webgl.createProgram('wallpaper_groups', new WallpaperGroupsShader());

				(webgl.programs["wallpaper_groups"].shader as WallpaperGroupsShader).u_documentSize = new Uniform.Uniform2f(documentWidth, documentHeight);
				(webgl.programs["wallpaper_groups"].shader as WallpaperGroupsShader).u_inputSize = new Uniform.Uniform2f(inputSizeWidth, inputSizeHeight);
				(webgl.programs["wallpaper_groups"].shader as WallpaperGroupsShader).u_group = new Uniform.Uniform1i(store.get('group'));
				webgl.useProgram('wallpaper_groups');
				break;

			case ModuleTypes.Kaleidoscope:
				store = module as ModuleKaleidoscopeStore;

				if(!webgl.programs["kaleidoscope"]) webgl.createProgram('kaleidoscope', new KaleidoscopeShader());

				(webgl.programs["kaleidoscope"].shader as KaleidoscopeShader).u_documentSize = new Uniform.Uniform2f(documentWidth, documentHeight);
				(webgl.programs["kaleidoscope"].shader as KaleidoscopeShader).u_inputSize = new Uniform.Uniform2f(inputSizeWidth, inputSizeHeight);
				(webgl.programs["kaleidoscope"].shader as KaleidoscopeShader).u_sides = new Uniform.Uniform1f(store.get('sides'));
				(webgl.programs["kaleidoscope"].shader as KaleidoscopeShader).u_angle = new Uniform.Uniform1f(store.get('angle'));
				
				webgl.useProgram('kaleidoscope');
				break;
		}

		webgl.render();
	}
}